import { useDispatch } from 'react-redux';

import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';

export const useSummaryFieldLinks = () => {
    const dispatch = useDispatch();

    return {
        openLenderFromRate: () => {
            dispatch(interactionAnalyticsActionCreators.mvRateLink());
            dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.Lender));
        },
        openIncentivesFromProgram: () => {
            dispatch(interactionAnalyticsActionCreators.mvIncentivesLink());
            dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.Incentives));
        }
    };
};
